<template>
  <div>

    <div class="container">
      <div style="margin-bottom: 20px;">订单审批流程</div>
      <el-form
        :rules="rules"
        :inline="true"
        :model="workflowCompany"
        ref="workflowCompany"
      >
        <el-form-item label="审批流程名称：" prop="workflowDefinitionName">
          <el-input
            v-model.trim="workflowCompany.workflowDefinitionName"
            maxlength="20"
            placeholder="请输入内容"
          ></el-input>
        </el-form-item>
      </el-form>
      <div class="tips">
        <span
          style="
            font-size: 12px;
            float: 20px;
            margin: 0 0 20px 5px;
            display: inline-block;
          "
        >
          说明：审批流程设置支持自定义审批层级节点，在每个节点中，可以设置多个审批人，其中的任何一人审批通过后即可进入下一层级审批节点。
        </span>
      </div>
      <!--表单添加-->
      <el-button type="success" @click="AddListRow('workflowCompany')"
        >添加审批节点</el-button
      >
      <TableList
        style="margin-top: 15px"
        :loading="false"
        :table-data="tableData"
        :table-label="tableLabel"
      >
        <template v-slot:idx="idx">
          第{{ idx.scope.$index + 1 }}审批节点
        </template>
        <template v-slot:approver="approver">
          <el-col :span="18">
            <div style="display: flex;">
                <el-tooltip
              class="item"
              effect="light"
              :disabled="disabledFlag(approver.scope.row.approverList)"
              :content="approver.scope.row.approverListStr"
              placement="top"
            >
              <el-input
                v-model="approver.scope.row.approverListStr"
                style="width: 84%;"
                :disabled="true"
              />
            </el-tooltip>
          <!-- </el-col>
          <el-col :span="5"> -->
            <el-button
              size="mini"
              type="primary"
              plain
              icon="el-icon-search"
              :disabled="false"
              @click="
                editApprover(
                  approver.scope.row,
                  approver.scope.$index
                )
              "
            />
            </div>
          
          </el-col>
        </template>
        <!-- 操作 -->
        <template v-slot:operation="tData">
          <el-button
            size="mini"
            type="danger"
            @click="handleDelete(tData.scope.$index)"
            >删除审批节点</el-button
          >
        </template>
      </TableList>
      <div style="display: flex;justify-content: space-between;margin-top: 20px;">
        <el-button @click="handleBack">返回</el-button>
        <el-button type="primary" @click="handleAddPurchase('workflowCompany')"
          >确定添加</el-button
        >
      </div>
    </div>

    <AddSupplierDialog 
      :addSupplierVisible.sync="addSupplierVisible"
      @getSelectCompany="getSelectCompany"
      :companyTableList="companyTableList"
      v-if="addSupplierVisible"
      ></AddSupplierDialog>
  </div>
</template>

<script>
import { isSpace } from "../../../utils/validate";
import TableList from "@/modules/projectA/components/common/e-table-list";
import Api from "../../../api/company/index";
import AddSupplierDialog from './addSupplierDialog'
export default {
  name: "",
  components: {
    TableList,
    AddSupplierDialog
  },
  data () {
    const validateSpace = (rule, value, callback) => {
      if (isSpace(value)) {
        return callback(new Error("请输入非空格字符！"));
      } else if (!value) {
        return callback(new Error("请输入必填项！"));
      } else {
        return callback();
      }
    };
    return {
      input: "",
      workflowCompany: {
        workflowDefinitionName: "",
        companyName: "",
        WorkflowCompanySku: [],
      },
      repetitionFlag: false,
      rules: {
        workflowDefinitionName: [
           {pattern:/^[\w\u4e00-\u9fa5]+$/,message:'输入框类型：汉字，英文，数字，英文下划线。',trigger: "blur",},
          { required: true, trigger: "blur", validator: validateSpace },
        ],
      },
      tableData: [],
      tableLabel: [
        {
          label: "审批节点",
          param: "orderNo",
          align: "center",
          slot: "idx",
        },
        {
          label: "审批人",
          param: "aftersalesNo",
          align: "center",
          slot: "approver",
        },
        {
          label: "操作",
          fixed: "right",
          align: "center",
          slot: "operation",
        },
      ],
      approverEdit_flag: false,
      addSupplierVisible:false,
        companyTableList: [],
        tableInx:''
    };
  },
  created () {
    if (
      JSON.parse(this.$getStore("createPurchaseAuditPath")).path ==
      "purchaseAudit"
    ) {
      // this.$setStore("tableData", []);
      // this.$setStore("confirmWorkFlowSkusList", null);
    } else {
      this.workflowCompany.workflowDefinitionName =
        this.$getStore("createName");
    }
  },
  methods: {
    //点击加号添加一行数据
    AddListRow (workflowCompany) {
      this.$refs[workflowCompany].validate((valid) => {
        if (valid) {
          this.tableData.push({});
          this.$setStore(
            "workflowDefinitionName",
            this.workflowCompany.workflowDefinitionName
          );
          this.$setStore("tableData", this.tableData);
        } else {
          console.log("请输入审批流程名称");
          return false;
        }
      });
    },

    disabledFlag (val) {
      if (val) {
        return false;
      } else {
        return true;
      }
    },

    handleDelete (index) {
      this.$confirm("该审批流程将被删除，是否继续？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          try {
            // 弄明白 confirmWorkFlowSkusList 这是数组是干啥的
            this.tableData.splice(index, 1);
              this.$message({
                type: "success",
                message: "删除成功!",
              });
              this.companyTableList.length = 0
              // this.tableData.forEach((item,index) => {
              //   this.$set(item,'auditNodeName', ('第' + (index + 1) + '审批节点'))
              // })
              return;
          } catch (error) {
            console.log(error);
          }
        })
        .catch(() => { });
    },
    editApprover (row, index) {
      this.tableInx = index
      this.addSupplierVisible = true
      this.companyTableList = row.approverList
      // this.setApproverStore(workflowDefinitionName, index);
      // this.$router.push({
      //   name: "approverEdit",
      //   params: {
      //     workflowDefinitionName: workflowDefinitionName,
      //     index: index,
      //   },
      // });
    },
    handleAddPurchase (workflowCompany) {
      if (this.workflowCompany.workflowDefinitionName == "") {
        this.$refs[workflowCompany].validate((valid) => {
          if (!valid) {
            return false;
          }
        });
        return;
      }
      let dataArr = JSON.parse(this.$getStore("getWorkflowListTableData"));
      dataArr.map((item) => {
        if (
          item.workflowDefinitionName ==
          this.workflowCompany.workflowDefinitionName
        ) {
          this.repetitionFlag = true;
        }
      });
      if (this.repetitionFlag) {
        this.repetitionFlag = false;
        return this.$message.error("已存在同名称审批流程，请重新命名!");
      }
      if (this.tableData.length < 1) {
        this.$message({
          type: "error",
          message: "请先添加审批节点！",
        });
        return;
      }
      // let confirmWorkFlowSkusList = JSON.parse(
      //   this.$getStore("confirmWorkFlowSkusList")
      // );
      this.tableData.map((item) => {
        if (item.approverList == "") {
          this.$message({
            type: "info",
            message: "某审批节点为空，请查看！",
          });
          return;
        }
      });
      let params = {
        workflowDefinitionName: "",
        workflowSkus: [],
      };
      params.workflowDefinitionName =
        this.workflowCompany.workflowDefinitionName;

      this.tableData.forEach((param,index) => {
        param.approverList.forEach((skuParam) => {
          let each = {
            approverContact: skuParam.mobile,
            approverId: skuParam.memberId,
            approverName: skuParam.memberName,
            approverRealName: skuParam.realName,
            levelName: "第" + (index + 1) + "审批节点",
            level: index + 1,
            companyName: "",
          };
          params.workflowSkus.push(each);
        });
      });
      Api.addWorkflow(params).then((res) => {
        if (res.code == "200") {
          this.$message({
            type: "success",
            message: "添加成功!",
          });
          this.removeStore();
          this.goToUrl();
        } else {
          // this.$message({
          //   type: "info",
          //   message: res.message,
          // });
        }
      });
    },
    goToUrl () {
                this.$store.state.tagsList.map((item, index) => {
                    if (item.fullPath == this.$route.path) {
                        this.$store.state.tagsList.splice(index, 1);
                    }
                })
                this.$router.go(-1);
            },
    removeStore () {
      this.workflowCompany.workflowDefinitionId = ''
        this.workflowCompany.workflowDefinitionName = ''
        this.tableData = []
    },
    getSelectCompany(val){
        this.$set(this.tableData[this.tableInx],'approverList',[...val])
    
        this.companyTableList = [...val];
        
        let tmpArr = ''
        this.tableData[this.tableInx].approverList.forEach((item) => {
          tmpArr += item.realName + ','
        })

        tmpArr=tmpArr.substring(0,tmpArr.length-1)
        this.$set(this.tableData[this.tableInx],'approverListStr',tmpArr)
        },
        handleBack () {
      this.removeStore();
      this.goToUrl();
    },
  },
};
</script>

<style scoped lang="scss">
::v-deep.el-form-item--small .el-form-item__error{
    width: 270px;
  }
</style>
